import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentTabsInEventDto extends EpimsBaseEntityDto {
  
  IncidentEventTypeId: string;
  EventName: string;
  IncidentTabsId: string;
  TabName: string;  
  Position: number;
  SubscriptionUserId: string;  
  Version: number;
}
